module.exports = __webpack_public_path__ + "img/pay-offline-img.f6bcc5d1.png";